import { fieldCantBeEmptyMsg, t } from '../../i18n/index.js';
import { InputComponent } from '../components/InputComponent.js';
import type { OptionalInputComponentProps } from '../components/InputComponent.js';

export const TextInput = ({
  name = 'text',
  type = 'text',
  label,
  placeholder,
  required = true,
  disabled = false,
  validate,
  onChange,
  optional,
  ...rest
}: OptionalInputComponentProps) => {
  const requiredValidate = (value: string) => (required && !value ? t.VPVR(fieldCantBeEmptyMsg) : undefined);
  const combinedValidate = (value: string) => requiredValidate(value) || (validate && validate(value));

  return (
    <InputComponent
      validate={combinedValidate}
      name={name}
      type={type}
      label={label}
      placeholder={placeholder}
      required={required}
      disabled={disabled}
      onChange={onChange}
      optional={optional}
      {...rest}
    />
  );
};
